import React from "react";
import "./BlogCard.scss";

export default function BlogCard({blog, isDark}) {
  const openUrlInNewTab = (url) => {
    if (!url) return;
    window.open(url, "_blank");
  };

  return (
    <div 
      className={isDark ? "blog-container dark-mode" : "blog-container"}
      onClick={() => openUrlInNewTab(blog.url)}
    >
      <div className={isDark ? "dark-mode blog-card" : "blog-card"}>
        <h3 className={isDark ? "dark-mode blog-title" : "blog-title"}>
          {blog.title}
        </h3>
        <p className={isDark ? "dark-mode blog-description" : "blog-description"}>
          {blog.description}
        </p>
      </div>
    </div>
  );
}
